'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _prefix = require('../prefix');

var _prefix2 = _interopRequireDefault(_prefix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Support writing-mode prop syntax.
// https://caniuse.com/#search=writing-mode
exports['default'] = {
  noPrefill: ['writing-mode'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'writing-mode') return false;
    if (_prefix2['default'].js === 'Webkit' || _prefix2['default'].js === 'ms') {
      return _prefix2['default'].css + prop;
    }
    return prop;
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/css-vendor/lib/plugins/writing-mode.js
// module id = 22
// module chunks = 0